<template lang="pug">
  section(class="jumbo")
    .img
      img(src="assets/images/jumbo.jpg", alt="")

    .jumbo-wrapper
      .jumbo-figure
        h1 DEL STEP A LAS PESAS
          small La tendencia femenina por preferir deportes con alta exigencia física.
</template>

<script>
  export default  {
    name: 'jumbo',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .jumbo {
    max-height: 90vh;
    overflow: hidden;
    position: relative;
    @media all and (max-width: 800px){
      min-height: 60vh;
    }
  }
  .img{
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 0;
    height: 0;
    background-color: black;
    @media all and (max-width: 800px){
      min-height: 60vh;
      padding: 0;
      height: auto;
    }
    &:before{
      content: '';
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      // background: url(../assets/grid.png);
      position: absolute;
      z-index: 2;
    }
    iframe,
    video,
    img{
      position: absolute;
      top: -10%;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      filter: grayscale(100%);
      opacity: 0.7;
      @media all and (max-width: 800px){
        object-fit: cover;
      }
    }
  }
  .jumbo-wrapper{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .jumbo-figure{
    max-width: 80%;
    text-align: center;
  }
  h1{
    color: white;
    font-weight: 900;
    @include fluid-type(360px, 1440px, 30px, 70px);
    small {
      display: block;
      font-size: 2rem;
      @media all and (max-width: 800px){
        font-size: 1.2rem;
      }
    }
  }
</style>
